import { useFormContext } from "react-hook-form";
import { useUpdateEffect } from "react-use";

import { usePaymentOptionContext } from "checkout-experience/components/payment-method/payment-option-provider";
import { ChexFieldValues } from "checkout-query-client/types/chex-form-fields";

export const useResetBillingOnCountryChange = () => {
  const { paymentOption } = usePaymentOptionContext() ?? {};
  const { formId = "" } = paymentOption ?? {};

  const { watch, resetField } = useFormContext();

  const { billingAddressCountry: countryFieldValue } = (watch(`${formId}`) ??
    {}) as ChexFieldValues;

  useUpdateEffect(() => {
    resetField(`${formId}.billingAddressAddressLine1`);
    resetField(`${formId}.billingAddressAddressLine2`);
    resetField(`${formId}.billingAddressCity`);
    resetField(`${formId}.billingAddressAdministrativeArea`);
    resetField(`${formId}.billingAddressZip`);
  }, [countryFieldValue]);
};
